import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useDeleteSelectedClaims() {
    const { oktaAuth } = useOktaAuth();

    function insertNoteHistory(inputParameters) {
        let accessToken = oktaAuth.getAccessToken();

        let parameters = {
            user: inputParameters.user,
            pMID: inputParameters.pMID,
            selectedLocations: inputParameters.selectedLocations,
            selectedManualPaymentDetailIds: inputParameters.selectedManualPaymentDetailIds,
        };

        console.log(parameters);

        axios
            .post(
                `api/ManualRemittance/DeleteManualRemittanceDetail`,
                parameters,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            )
            .then((response) => {
                // console.log("Post request successful:", response);
                inputParameters.callback();
            })
            .catch((e) => {
                console.log("Post request failed:", e);
            });
    }

    return useMutation({
        mutationFn: async (mutateParameter) => {
            insertNoteHistory(mutateParameter);
        }
    });

}